import React from 'react';
import dayjs from 'dayjs';

import Badge from 'modules/common/components/Badge';
import { formatNumber } from 'helper';
import { getSeries } from 'modules/common/chart/chartTheme';

export const TRANSACTION_HISTOGRAM = 'TRANSACTION_HISTOGRAM';
export const TRANSACTION_COMPARE = 'TRANSACTION_COMPARE';

export const COMPARE_OPTIONS = [
  { label: 'By Day', value: 'day' },
  { label: 'By Month', value: 'month' },
  { label: 'By Year', value: 'year' },
];

const MAP_STATUS = {
  // TRANSFORM STATUS LABEL
  PAID: 'APPROVED',
};

export const transactionTableFormat = [
  {
    id: 'created_at',
    label: 'DATE',
    key: 'created_at',
  },
  { id: 'organization_name', label: 'AGENCY', key: 'organization_name' },
  {
    id: 'balance',
    label: 'SMS',
    key: ({ debit, credit }) => (
      <span>{formatNumber(+debit ? debit : credit, 0)}</span>
    ),
    labelClassName: 'pr-10 whitespace-nowrap flex justify-end',
    contentClassName: 'pr-10 whitespace-nowrap text-right',
  },
  {
    id: 'refno',
    label: 'REFERENCE NO.',
    key: ({ status, refno }) => (
      <span>{status === 'DRAFT' ? '--' : refno}</span>
    ),
  },
  {
    id: 'updated_at',
    label: 'UPDATED AT',
    key: (item) => (
      <span>{item?.status === 'DRAFT' ? '--' : item?.updated_at}</span>
    ),
  },
  {
    id: 'status',
    label: 'STATUS',
    key: (item) => <Badge status={MAP_STATUS[item?.status] || item?.status} />,
  },
];

export const statusOptions = [
  { id: 0, label: 'All Status', value: '' },
  { id: 1, label: 'Paid', value: 'success' },
  { id: 2, label: 'Pending', value: 'pending' },
  { id: 3, label: 'Draft', value: 'draft' },
];

/*
 * The fourth of the four unrelated palettes the rebrand collapses. Now the one
 * shared categorical series palette, read from theme.css.
 */
export const COLORS = getSeries();

export const MAP_ROWS = {
  day: [
    '12:00 AM',
    '01:00 AM',
    '02:00 AM',
    '03:00 AM',
    '04:00 AM',
    '05:00 AM',
    '06:00 AM',
    '07:00 AM',
    '08:00 AM',
    '09:00 AM',
    '10:00 AM',
    '11:00 AM',
    '12:00 PM',
    '01:00 PM',
    '02:00 PM',
    '03:00 PM',
    '04:00 PM',
    '05:00 PM',
    '06:00 PM',
    '07:00 PM',
    '08:00 PM',
    '09:00 PM',
    '10:00 PM',
    '11:00 PM',
  ],
  month: [
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '23',
    '24',
    '25',
    '26',
    '27',
    '28',
    '29',
    '30',
    '31',
  ],
  year: [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ],
};

export const MAP_SERIES_FORMAT = {
  day: 'MM/DD/YYYY',
  month: 'MMM YYYY',
  year: 'YYYY',
};

export const MAP_GROUP = {
  day: 'hour',
  month: 'day',
  year: 'month',
};

export const MAP_GROUP_FULL_NAME = {
  day: 'DAILY',
  month: 'MONTHLY',
  year: 'YEARLY',
};

export const MAP_KEY = {
  day: 'YYYY-MM-DD',
  month: 'YYYY-MM',
  year: 'YYYY',
};

export const buildId = (date, mode) => {
  if (!date) return null;
  return dayjs(date).format(MAP_KEY[mode]);
};

export default {};
